module.exports = __webpack_public_path__ + "static/img/index_bottom.69313a7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cec2022/index_bottom.png
// module id = nkS4
// module chunks = 4